export class Constants {
  static readonly ALL_SELLER_ROLES = ['ROLE_SELLER', 'ROLE_SELLER_ADMIN'];
  static readonly ROLE_SELLER = 'ROLE_SELLER';
  static readonly ROLE_SELLER_ADMIN = 'ROLE_SELLER_ADMIN';

  static readonly ALL_OPERATOR_ROLES = ['ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN'];
  static readonly ROLE_OPERATOR = 'ROLE_OPERATOR';
  static readonly ROLE_OPERATOR_ADMIN = 'ROLE_OPERATOR_ADMIN';
  static readonly ROLE_MASTER_OPERATOR = 'ROLE_MASTER_OPERATOR';

  static readonly ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
  static readonly EQUIPE_MP_SHOP = 'Equipe MP | score 100';
  static readonly EQUIPE_MP_SHOP_CODE_FR = 'SHOP_OPERATOR_SCORE_100_FR';
  static readonly PREACTIVATION_SHOP_CODE_FR = 'SHOP_OPERATOR_SCORE_41_FR';
  static readonly EQUIPE_MP_SHOP_CODE_BE = 'SHOP_OPERATOR_SCORE_100_BE';
  static readonly PREACTIVATION_SHOP_CODE_BE = 'SHOP_OPERATOR_SCORE_41_BE';
  static readonly MASTER_CATALOGUE_SHOP_CODE_FR = 'SHOP_MASTER_CATALOG_FR';
  static readonly MASTER_CATALOGUE_SHOP_CODE_BE = 'SHOP_MASTER_CATALOG_BE';
  static readonly PREACTIVATION_SHOP = 'Préactivation | score 41';

  static readonly EQUIPE_MP_SHOP_NAME = 'Equipe MP';
  static readonly PREACTIVATION_SHOP_NAME = 'Préactivation';
  static readonly MASTER_CATALOGUE_SHOP_NAME = 'Master Catalogue';

  static readonly EQUIPE_MP_SHOP_LABEL = 'Equipe MP | 100';
  static readonly PREACTIVATION_SHOP_LABEL = 'Préactivation | 41';
  static readonly MASTER_CATALOGUE_SHOP_LABEL = 'Master Catalogue | 101';

}